import { getColor } from 'common/constants/_colors';
import styled from 'styled-components';

export const StyledFiltersGroup = styled.span`
  &:not(:last-child) {
    padding-right: 1rem;
    margin-right: 1rem;
    border-right: 1px solid #000;
  }
`;
export const StyledFilterName = styled.span`
  font-weight: 500;
  text-transform: capitalize;
  margin-right: 0.5rem;
`;

export const StyledFilterValues = styled.span``;

export const StyledFilterLine = styled.div`
  margin-right: 1rem;
  background-color: ${getColor('zircon')};
  color: ${getColor('shuttleGray')};
  padding: 0.5rem 1rem;
  margin-top: 1rem;
  letter-spacing: 0.2px;
  border: 1px solid #a3a3a3;
  line-height: 2rem;
`;

export const StyledOptionsFooter = styled.footer`
  margin-top: 1rem;
`;

export const StyledSelectedFilters = styled.div`
  color: ${getColor('shuttleGray')};
  font-weight: 400;
  & > header {
    display: flex;
    align-items: center;
  }
`;
